import * as constants from './constants'
import { IWizardProject } from '../types/wizardData'
import { toastMsg } from '../../../components/Toast/toastMsg'
import { ActionCreator } from 'redux'
import { ThunkAction, ThunkDispatch } from 'redux-thunk'
import { ProjectsApi } from '../../../api/projectApi'
import { IProject } from '../types/project'
import { ProjectsState } from '../reducers'

export type WizardThunkResult<R> = ThunkAction<Promise<R>, ProjectsState, null, WizardActions>
export type WizadThunkDispatchType = ThunkDispatch<ProjectsState, null, WizardActions>

export interface WizardHasErrored {
  type: constants.WIZARD_HAS_ERRORED
  hasErrored: boolean
}

export interface SetWizardStep {
  type: constants.SET_WIZARD_STEP
  step: string
}

export interface SetProjectWizardData {
  type: constants.SET_PROJECT_WIZARD_DATA
  data: IWizardProject
}

export interface SetWizardFinishedSteps {
  type: constants.SET_WIZARD_FINISHED_STEPS
  steps: number[]
}

export interface WizardCreateProjectSuccess {
  type: constants.WIZARD_CREATE_PROJECT_SUCCESS
  project: IProject
}

export const wizardHasErrored = (hasErrored: boolean, error: Error, action?: string): WizardHasErrored => {
  if (action) {
    const errorMsg = error.message
    toastMsg(errorMsg, action, 'error')
  }
  return {
    type: constants.WIZARD_HAS_ERRORED,
    hasErrored: hasErrored
  }
}

export const setWizardStep = (step: string): SetWizardStep => {
  return {
    type: constants.SET_WIZARD_STEP,
    step
  }
}

export const setProjectWizardData = (data: IWizardProject): SetProjectWizardData => {
  return {
    type: constants.SET_PROJECT_WIZARD_DATA,
    data
  }
}

export const setWizardFinishedSteps = (steps: number[]): SetWizardFinishedSteps => {
  return {
    type: constants.SET_WIZARD_FINISHED_STEPS,
    steps
  }
}

export const wizardCreateProject: ActionCreator<WizardThunkResult<IProject>>
= (project: IWizardProject): WizardThunkResult<IProject> => {
  return async (dispatch: WizadThunkDispatchType) => {
    return ProjectsApi.createProject(project)
      .then(response => {
        dispatch(wizardCreateProjectSuccess(response))
        return response
      })
      .catch(error => {
        dispatch(wizardHasErrored(true, error.response.data, constants.WIZARD_CREATE_PROJECT))
        return {} as IProject
      })
  }
}

export const wizardCreateProjectSuccess = (project: IProject): WizardCreateProjectSuccess => {
  toastMsg(`Created ${project.name} project successfully.`, constants.WIZARD_CREATE_PROJECT_SUCCESS, 'success')
  return {
    type: constants.WIZARD_CREATE_PROJECT_SUCCESS,
    project
  }
}

export type WizardActions
  = SetWizardStep
  | SetProjectWizardData
  | SetWizardFinishedSteps
  | SetWizardStep
  | WizardCreateProjectSuccess
  | WizardHasErrored
